export default __webpack_public_path__ + "static/media/TR-909.a474f333.ttf";